import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "../lib/api";

const AppDataContext = createContext(null);
export const useAppData = () => useContext(AppDataContext);

const CLINIC_KEY = "ruralcare_clinic";

export function AppDataProvider({ children }) {
  const [clinics, setClinics] = useState([]);
  const [categories, setCategories] = useState([]);
  const [banners, setBanners] = useState([]);
  const [settings, setSettings] = useState({ whatsapp_active: false });
  const [clinicId, setClinicIdState] = useState(localStorage.getItem(CLINIC_KEY) || "all");

  const refresh = useCallback(async () => {
    try {
      const [c, cat, b, s] = await Promise.all([
        api.get("/clinics"),
        api.get("/categories"),
        api.get("/banners"),
        api.get("/settings"),
      ]);
      setClinics(c.data);
      setCategories(cat.data);
      setBanners(b.data);
      setSettings(s.data);
    } catch (e) {
      console.warn("App data refresh failed (offline or backend unreachable):", e);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const setClinicId = useCallback((id) => {
    setClinicIdState(id);
    localStorage.setItem(CLINIC_KEY, id);
  }, []);

  const catName = useCallback((kind, slug) => {
    const found = categories.find((c) => c.kind === kind && c.slug === slug);
    return found ? found.name : slug;
  }, [categories]);

  const catsByKind = useCallback(
    (kind) => categories.filter((c) => c.kind === kind && c.active),
    [categories]
  );

  const value = useMemo(
    () => ({ clinics, categories, banners, settings, clinicId, setClinicId, refresh, catName, catsByKind }),
    [clinics, categories, banners, settings, clinicId, setClinicId, refresh, catName, catsByKind]
  );

  return (
    <AppDataContext.Provider value={value}>
      {children}
    </AppDataContext.Provider>
  );
}
